import ImageLevel1 from 'src/assets/images/levels/1.png'
import ImageLevel2 from 'src/assets/images/levels/2.png'
import ImageLevel3 from 'src/assets/images/levels/3.png'
import ImageLevel4 from 'src/assets/images/levels/4.png'
import ImageLevel5 from 'src/assets/images/levels/5.png'
import ImageLevel6 from 'src/assets/images/levels/6.png'
import ImageLevel7 from 'src/assets/images/levels/7.png'
import ImageLevel8 from 'src/assets/images/levels/8.png'
import ImageLevel9 from 'src/assets/images/levels/9.png'
import ImageLevel10 from 'src/assets/images/levels/10.png'
import CelebrateBadge from 'src/assets/images/celebrate-badge.png'
import CelebrateBadge2 from 'src/assets/images/celebrate-badge-2.png'

import PlaceholderImg from 'src/assets/images/placeholder.png'
import NoImg from 'src/assets/images/noimg.png'
import NoImgLandscape from 'src/assets/images/noimg-landscape.png'
import AvatarDefaultXs from 'src/assets/images/avatar-default-xs.png'
import IntroLogo from 'src/assets/images/intro-logo.png'

import GiftCardDefaultAmazon from 'src/assets/images/giftcard/amazon.png'
import GiftCardDefaultPaytm from 'src/assets/images/giftcard/paytm.png'
import GiftCardDefaultFlipkart from 'src/assets/images/giftcard/flipkart.png'
import GiftCardDefaultGooglePlay from 'src/assets/images/giftcard/google-play.jpg'
import GiftCardDefaultOther from 'src/assets/images/giftcard/other.jpg'
import AmazonLogo from 'src/assets/images/giftcard/amazon-logo.png'
import GooglePlayLogo from 'src/assets/images/giftcard/google-play-logo.png'
import PaytmLogo from 'src/assets/images/giftcard/paytm-logo.png'
import FlipkartLogo from 'src/assets/images/giftcard/flipkart-logo.png'
import GiftBoxIcon from 'src/assets/images/giftbox.png'

const Assets = {
    ImageLevel1,
    ImageLevel2,
    ImageLevel3,
    ImageLevel4,
    ImageLevel5,
    ImageLevel6,
    ImageLevel7,
    ImageLevel8,
    ImageLevel9,
    ImageLevel10,
    CelebrateBadge,
    CelebrateBadge2,

    PlaceholderImg,
    NoImg,
    NoImgLandscape,
    GiftCardDefaultAmazon,
    GiftCardDefaultPaytm,
    GiftCardDefaultFlipkart,
    GiftCardDefaultGooglePlay,
    GiftCardDefaultOther,
    AmazonLogo,
    GooglePlayLogo,
    PaytmLogo,
    FlipkartLogo,
    GiftBoxIcon,
    AvatarDefaultXs,
    IntroLogo
}

export default Assets
